import $ from 'jquery';
let app = app || {};
$(function(){

	objectFitImages('.keyVisual img, .suna img');

	let deviceFlg;
	app.init = function () {
		app.scrollEvent();
		app.pageLink();
		app.menuTrigger();
		app.deviceFlg();
		app.accordion();
		app.paypalForm();
		app.permission();
		app.selectCheck();
		app.formMustToggle();
	}

	app.deviceFlg = function(){
		$(window).on("load resize", function(){
			if($(this).width() >= 1101) deviceFlg = 'pc';
			if($(this).width() <= 1100) deviceFlg = 'tablet';
			if($(this).width() <= 600) deviceFlg = 'sp';
		});
	}

	app.scrollEvent = function(){
		let self = this;
		$(window).on("scroll", function(){
			let ScrollPosition = $(this).scrollTop();
			self.bgFixed(ScrollPosition);
		});
	}

	app.bgFixed = function (ScrollPosition) {
		if ($('.bg-area').length) {
			let bgAreaPosition = $('.bg-area').offset().top;
			let buffer = 0;
			if(deviceFlg == 'sp'){
				buffer = 80;
			}
			if(ScrollPosition > bgAreaPosition - buffer){
				$('.bg-area').addClass('fixed');
			}else{
				$('.bg-area').removeClass('fixed');
			}
		}
	}

	app.pageLink = function () {
	  $('a[href^="#"]').click(function(e) {
	  	e.preventDefault();
	    var speed = 400;
	    var href= $(this).attr("href");
	    var target = $(href == "#" || href == "" ? 'html' : href);
	    var position = target.offset().top -82;
	    $('body,html').animate({scrollTop:position}, speed, 'swing');
	    return false;
	  });
	}

	app.menuTrigger = function () {
		$('.menu-trigger').on('click',function(){
		  $(this).toggleClass('active');
		  $('.sidebarInfo').toggle();
		});
	}

	app.accordion = function () {
		$('.js-Accordion').on('click',function(e){
			$(this).next('.js-Accordion-Target').slideToggle(200);
		});
	}

	app.paypalForm = function () {
		$('#standardBtn').on('click',function(){
		  $('#paypalFormStandard').submit();
		});
		$('#premiumBtn').on('click',function(){
		  $('#paypalFormPremium').submit();
		});
	}

	app.permission = function () {
		$('#permission_check').on('click', function(){
      if($('.permission').prop('checked')){
        $('#main-form').submit();
      } else {
        alert('利用規約に同意するの項目にチェックをしてください。');
        return false;
      }
    });
	}

	app.selectCheck = function(){
		$('.selectDateBox input').on('keyup', function(e){
			var inputValue = $(this).val();
			var inputLength = $(this).val().length;
			if(inputLength >= 3 ){
				inputValue = inputValue.slice(0, -1);
				$(this).val(inputValue);
			}
		});	
	}

	app.formMustToggle = function(){
		$('.selectCourse').on('change', function(e){
			var selectCourse = $(this).val();
			if(selectCourse == '受講・イベント申し込み'){
				$('.formLine-change').addClass('must');
			}else{
				$('.formLine-change').removeClass('must');
			}
		});	
	}


	app.init();

});


// WEBPACK FOOTER //
// ./src/js/app.js